//
//
//
//

import NewDesignBlogPost from "./NewDesignBlogPost.vue";
import LegacyBlogPost from "./LegacyBlogPost.vue";

export default {
  name: "SingleBlogPost",
  transition: "default",
  components: {
    NewDesignBlogPost,
    LegacyBlogPost,
  },
  computed: {
    blogPostComponent() {
      // Use new design if new_design is true, otherwise use legacy design
      return this.data?.attributes?.new_design
        ? "NewDesignBlogPost"
        : "LegacyBlogPost";
    },
  },
  async asyncData({ $axios, params, error }) {
    try {
      const qs = require("qs");
      const query = qs.stringify(
        {
          // publicationState: "preview",
          filters: {
            slug: {
              $eq: params.slug,
            },
          },
        },
        {
          encodeValuesOnly: true,
        }
      );
      // console.log("SLUG QUERY: " + query);
      var data = await $axios.$get(
        `${process.env.api_url}/api/blog-posts?${query}&populate=deep&locale=all`
      );
      // console.log("SLUG PARAMS: ", params);
      // console.log("SLUG DATA: ", data);

      if (!data.data.length) {
        data = false;
      }

      return { data: data.data[0] };
    } catch (err) {
      error({
        statusCode: 404,
        message: "Page not found",
      });
    }
  },
  head() {
    const rootUrl = process.env.root_url || 'https://www.techcast.com';
    return {
      title: `${
        this.data.attributes.headline && this.data.attributes.headline
      }`,
      titleTemplate: "Techcast | Blog - %s",
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        {
          hid: "description",
          name: "description",
          content:
            this.data.attributes.page_description &&
            this.data.attributes.page_description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: `${
            this.data.attributes.headline && this.data.attributes.headline
          }`,
        },
        {
          hid: "og:desc",
          name: "og:description",
          content:
            this.data.attributes.page_description &&
            this.data.attributes.page_description,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `${rootUrl}${this.$route.path}`,
        },
        // twitter card
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: `${
            this.data.attributes.headline && this.data.attributes.headline
          }`,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content:
            this.data.attributes.page_description &&
            this.data.attributes.page_description,
        },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: `${rootUrl}${this.$route.path}`,
        },
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `${rootUrl}${this.$route.path}`,
        },
      ],
    };
  },
};
